import React, { useEffect, useState } from 'react';
import { BrandLogo } from '../components/brand/BrandLogo';
import { LeaderboardCard } from '../components/leaderboard/LeaderboardTable';
import { leaderboardService } from '../services/leaderboardService';

const PAGE_SIZE = 50;

export function LeaderboardPage() {
  const [page, setPage] = useState(1);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');

    leaderboardService
      .getLeaderboard(page, PAGE_SIZE)
      .then((data) => {
        setItems(data.items || []);
        setTotalPages(data.totalPages || 0);
        setTotal(data.total || 0);
      })
      .catch(() => {
        setItems([]);
        setTotalPages(0);
        setTotal(0);
        setError('โหลดอันดับไม่สำเร็จ');
      })
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="space-y-6">
      <section className="rounded-2xl border border-red-100 bg-gradient-to-br from-white via-red-50/30 to-brand-gold-light/20 p-6 text-center shadow-sm">
        <BrandLogo size="lg" className="mx-auto mb-3" />
        <h2 className="text-2xl font-bold text-brand-red">Leaderboard</h2>
        <p className="mt-2 text-sm text-gray-600">
          รวมยอดแทงและยอดถูกจากหวย + ยี่กี · เรียงตามเวลาที่ถูกล่าสุด · ทั้งหมด{' '}
          {total} คน
        </p>
      </section>

      {error ? (
        <p className="rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-brand-red">
          {error}
        </p>
      ) : null}

      {loading ? (
        <p className="py-10 text-center text-sm text-gray-500">กำลังโหลด...</p>
      ) : (
        <LeaderboardCard
          items={items}
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
}
